export default __webpack_public_path__ + "static/media/sos.920ec5cf.jpg";